// 官网埋点上报（匿名，静默失败）
const TRACK_API = (import.meta.env.VITE_API_BASE as string || "") + "/api/track";

function resolveChannel(): string {
  try {
    const u = new URLSearchParams(window.location.search);
    const src = u.get("utm_source") || u.get("utm_medium") || u.get("utm_campaign");
    if (src) {
      if (/google|baidu|bing|yahoo/.test(src)) return "google";
      if (/facebook|instagram|twitter|x|youtube|tiktok|weibo|wechat|telegram/.test(src)) return "social";
      if (/ads|cpc|sem/.test(src)) return "ads";
      return "other";
    }
    const ref = document.referrer;
    if (!ref) return "direct";
    try {
      const host = new URL(ref).hostname;
      if (/google|baidu|bing|yahoo/.test(host)) return "google";
      if (/facebook|instagram|twitter|x\.com|youtube|tiktok|weibo|wechat|telegram/.test(host)) return "social";
      return "other";
    } catch {
      return "other";
    }
  } catch {
    return "other";
  }
}

export type TrackEvent = "pv" | "tool_use" | "download_click";

export function track(eventType: TrackEvent, payload?: { pagePath?: string; toolId?: string }): void {
  try {
    const body = {
      eventType,
      pagePath: payload?.pagePath || (eventType === "pv" ? window.location.pathname : undefined),
      toolId: payload?.toolId,
      channel: resolveChannel(),
      referer: document.referrer || undefined,
    };
    const blob = new Blob([JSON.stringify(body)], { type: "application/json" });
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(TRACK_API, blob);
    } else {
      fetch(TRACK_API, { method: "POST", body: blob, keepalive: true }).catch(() => {});
    }
  } catch {
    // 静默失败，不阻塞业务
  }
}

/** PV 埋点：路由变化时调用 */
export function trackPageView(): void {
  track("pv");
}
